import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'

@Component({
  selector: 'app-download-actions-renderer',
  template: `
    <button
      class="btn btn-link"
      style="padding: 0; margin-right: 15px; margin-left: 10px"
      (click)="downloadDocumentClicked()"
    >
      <i class="fa fa-download"></i> {{ name }}
    </button>
  `,
  standalone: false
})
export class DownloadDocumentRendererComponent implements AgRendererComponent {
  private params: any

  name = ''

  agInit(params: any): void {
    this.params = params
    this.name = params.data['Filename'] + ''
  }

  refresh(params: any): boolean {
    return false
  }

  public downloadDocumentClicked(): void {
    if (this.params.context.downloadHandler) {
      this.params.context.downloadHandler(this.params.data)
    }
  }
}
